module.exports = __webpack_public_path__ + "static/media/ParamTraining.6f651f49.svg";